<template>
  <div>
    <select
      class="default-select mb-5"
      v-model="certificate_teacher_id"
      :disabled="!experienceActive || disableSubmit"
      aria-label="Please select a teacher"
    >
      <option value="0">Please select teacher</option>
      <option v-for="teacher in certificate_teachers" :key="teacher.id" :value="teacher.id">
        {{ teacher.name }}
      </option>
    </select>
    <button
      class="btn btn-primary btn-size-medium mr-5"
      aria-disabled="true"
      v-if="!experienceActive || disableSubmit"
    >
      Submit Job Experience
    </button>
    <button v-else class="btn btn-primary btn-size-medium mr-5" @click="confirmSubmitExperience">
      Submit Job Experience
    </button>
    <vs-progress indeterminate color="primary" v-if="submitting"></vs-progress>
  </div>
</template>

<script>
import theApi from '@/mixins/theApi';
import store from '@/store/store';

export default {
  data() {
    return {
      disableSubmit: false,
      certificate_teacher_id: 0,
      submitting: false,
    };
  },
  computed: {
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    experienceActive() {
      return (
        this.experience && this.experience.active == 1 && this.experience.activities_completed == 1
      );
    },
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    certificate_teachers() {
      return store.getters['authStudent/certificate_teachers'];
    },
  },
  methods: {
    confirmSubmitExperience() {
      const vm = this;
      let title = `Submit This Experience?`;
      let color = 'primary';
      let text =
        "Are you sure you want to submit now? Once you do, you can't go back and edit your experience.";
      this.$vs.dialog({
        type: 'confirm',
        color: color,
        title: title,
        text: text,
        accept: async function () {
          await vm.submitExperience();
        },
      });
      //}
    },
    submitExperience() {
      this.disableSubmit = true;
      const formData = new FormData();
      let activeVjeId = this.activeExperienceID;
      formData.append('student_vje_id', activeVjeId);
      formData.append('certificate_teacher_id', this.certificate_teacher_id);

      this.submitting = true;
      theApi.methods
        .makeCall(
          false,
          'experiences/submit_experience',
          'post',
          formData,
          'Experience submitted successfully!',
          true,
        )
        .then(
          (data) => {
            if (data.status == 'OK') {
              this.submitting = false;
              store.commit('authStudent/setActiveExperienceID', null);
              const experience_data = {
                id: activeVjeId,
                data: data.save_data,
              };
              store.commit('authStudent/modifyExperience', experience_data);
            } else {
              this.submitting = false;
              this.disableSubmit = false;
            }
          },
          () => {
            this.submitting = false;
            this.disableSubmit = false;
          },
        );
    },
  },
};
</script>
